export const IGC_DEFAULT_TOOLTIP_TIMEOUT = 5000;